import { render, staticRenderFns } from "./item-address.vue?vue&type=template&id=02935630&scoped=true"
import script from "./item-address.vue?vue&type=script&lang=ts"
export * from "./item-address.vue?vue&type=script&lang=ts"
import style0 from "./item-address.vue?vue&type=style&index=0&id=02935630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02935630",
  null
  
)

export default component.exports